import { ErrorBoundary } from '@sentry/react';
import { useSetAtom } from 'jotai';
import { Suspense, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { selectedFilterSetIdAtom } from '@/atoms/filters/userFilters';
import { UserFiltersButtons } from '@/components/filters/UserFilters/UserFiltersButtons';
import { LoadFilterSetModal } from '@/components/modal/LoadFilterSetModal/LoadFilterSetModal';
import { SaveFilterModal } from '@/components/modal/SaveFilterModal/SaveFilterModal';
import { FILTER_SET_ID } from '@/consts/searchKeys';
import { useLoadSelectedFilterSet } from '@/hooks/userFilters/useLoadSelectedFilterSet';

const UserFiltersWithData = () => {
  const setSelectedFilterSetId = useSetAtom(selectedFilterSetIdAtom);
  useLoadSelectedFilterSet();

  const [searchParams] = useSearchParams();
  const filterSetId = searchParams.get(FILTER_SET_ID);

  useEffect(() => setSelectedFilterSetId(filterSetId), [filterSetId]);

  return (
    <>
      <UserFiltersButtons />
      <SaveFilterModal />
      <LoadFilterSetModal />
    </>
  );
};

export const UserFilters = () => (
  <ErrorBoundary fallback={<UserFiltersButtons />}>
    <Suspense fallback={<UserFiltersButtons />}>
      <UserFiltersWithData />
    </Suspense>
  </ErrorBoundary>
);
